import type { ReactNode } from "react";
import React, { useContext } from "react";
import { DocsContext } from "../chrome/DocsContext";

export const LanguageDependantContent = (props: { tsMode: ReactNode; jsMode: ReactNode }) => {
  const { showTsLanguage } = useContext(DocsContext);
  return <>{showTsLanguage ? props.tsMode : props.jsMode}</>;
};
